import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Subsections } from '../SessionSignOffV4.constant';
import { MedicationSection } from './MedicationSection';
import { AppointmentSection } from './AppointmentSection';

export const FeedbackForUsSection = ({
  selectedSubSection,
  setSelectedSubSection,
  appointment,
  openGiggle,
}) => {
  useEffect(() => {
    if (!selectedSubSection) setSelectedSubSection(Subsections.REVIEW_MEDICATIONS);
  }, [selectedSubSection, setSelectedSubSection]);

  const renderSubsectionContent = () => {
    switch (selectedSubSection) {
      case Subsections.REVIEW_MEDICATIONS:
        return <MedicationSection appointment={appointment} />;
      case Subsections.UPCOMING_APPOINTMENTS:
        return <AppointmentSection appointment={appointment} openGiggle={openGiggle} />;
      default:
        return <div>Select a subsection</div>;
    }
  };

  return <Box padding="16px">{renderSubsectionContent()}</Box>;
};
